// extracted by mini-css-extract-plugin
export default {"Modal":"SDNtBfX8","ContentRoot":"MW221iCl"};